document.addEventListener('DOMContentLoaded', () => {
    const sectionContent = document.querySelector('.gh-content');
    const figure = sectionContent.querySelector('figure:first-of-type');
    if (figure) {
        figure.remove();
    }
    const title = sectionContent.querySelector('h1:first-of-type');
    if (title) {
        title.remove();
    }
    const subtitle = sectionContent.querySelector('h5:first-of-type');
    if (subtitle) {
        subtitle.remove();
        const newTitle = document.createElement('h2');
        newTitle.innerHTML = subtitle.innerHTML; 
        const newLocation = document.querySelector('.gh-article-meta');
        newLocation.parentNode.insertBefore(newTitle, newLocation);
    }
});

/* ==================== MODAL ==================== */
const modalViews = document.querySelectorAll('.nav__modal'),
      modalBtns = document.querySelectorAll('.nav__button'),
      modalCloses = document.querySelectorAll('.nav__modal-close'),
      modalLinks = document.querySelectorAll('.nav__link'); // Atualizado para 'nav__link'

let modal = function(modalClick) {
    modalViews[modalClick].classList.add('active-modal');
}

modalBtns.forEach((modalBtn, i) => {
    modalBtn.addEventListener('click', () => {
        modal(i);
    });
});

modalCloses.forEach((modalClose) => {
    modalClose.addEventListener('click', () => {
        modalViews.forEach((modalView) => {
            modalView.classList.remove('active-modal');
        });
    });
});

// Adiciona a lógica para fechar o modal e rolar para a âncora quando um link com a classe 'nav__link' é clicado
modalLinks.forEach(link => {
    link.addEventListener('click', function(event) {
        // Remove o comportamento padrão do link
        event.preventDefault();

        // Obtém o destino do link
        const targetId = this.getAttribute('href').substring(1);
        const targetElement = document.getElementById(targetId);

        // Fecha todos os modais com um atraso
        modalViews.forEach((modalView) => {
            modalView.classList.remove('active-modal');
        });

        // Usa um pequeno atraso para garantir que o modal esteja fechado antes de rolar para o destino
        setTimeout(() => {
            if (targetElement) {
                // Ajuste para rolagem suave com compensação de posição
                const offset = 100; // Ajuste este valor conforme necessário
                const elementPosition = targetElement.getBoundingClientRect().top + window.scrollY;
                window.scrollTo({
                    top: elementPosition - offset,
                    behavior: 'smooth'
                });
            }
        }, 300); // 300 ms é um valor de atraso, ajuste conforme necessário
    });
});

/* ==================== SHOW SCROLL UP ==================== */
function scrollUp() {
    const scrollUp = document.getElementById('scroll-up');
    //When the scroll is higher than 560 viewport height, add the shwo scroll class to the a tag with the scroll
    if(this.scrollY >= 560) scrollUp.classList.add('show-scroll'); else scrollUp.classList.remove('show-scroll');
}
window.addEventListener('scroll', scrollUp)
